const Events = require('PSEvents');
const State = require('PSState');
const PSConfig = require('PSConfig');
const i18n = require('i18n');
const GridSelector = require('GridSelector');
const PSUI = require('PSUIControl');
const { betValueDecorator } = require('PSUtils');

cc.Class({
    extends: cc.Component,

    properties: {
        rtpAndMaxWinLabel: cc.Label,
        gridSelector: GridSelector,
        betAmounts: [cc.Label],
        incButtons: [cc.Button],
        decButton: [cc.Button],
        betButton: [cc.Button]
    },

    onLoad () {
        this.PSSound = cc.find('PSUIInitializer/PSUI/Sound').getComponent('PSSound');

        Events.subscribe(Events.COMMON_INITIALIZED, () => { this.commonInitialized(); });
        Events.subscribe(Events.STATE_UPDATED, (state) => { this.updateState(state);  });
    },

    commonInitialized() {
        const { showRtpAndMaxWin, rtp, maxExposure } = PSConfig.get();

        this.rtpAndMaxWinLabel.node.active = showRtpAndMaxWin;
        this.rtpAndMaxWinLabel.string = i18n.t('rtp-and-maxwin', { '0': rtp, '1': maxExposure });

        const decorator = (value) => {
            return betValueDecorator(value, State.selectedBooster, i18n);
        }

        const betButtonSufficientModifier = (button, value) => {
            button.interactable = value <= State.balance;
            button.node.opacity = button.interactable ? 255 : 100;
        };

        const progessModifier = (button, value) => {
            const progressNode = button.node.getChildByName('progress');
            const progressSprite = progressNode.getComponent(cc.Sprite);
            const progress = State.progressPerBet[value];

            if (progress) {
                progressNode.active = true;
                progressSprite.fillRange = progress;
            } else {
                progressNode.active = false;
            }

        };

        const boosterModifier = (button, value) => {
            if (value !==  Number.MAX_SAFE_INTEGER) {
                const label = button.node.getChildByName('label');
                label.getComponent(cc.Label).string = decorator(value);
            }
        };
        const modifiers = [ betButtonSufficientModifier, boosterModifier ];

        if (State.progressPerBet) {
            modifiers.push(progessModifier);
        }

        const betChangedCallback = (selectedIndex) => {
            if (this.isInited) {
                PSUI.close();
            }
            State.set({
                betAmount: State.availableBetAmounts[selectedIndex]
            });
            this.updateState(State.get());
        };

        this.gridSelector.init(
            State.availableBetAmounts.map(value => value),
            this.betIndex,
            betChangedCallback,
            decorator,
            modifiers
        );
    },

    updateState (state) {
        this.isInited = true;

        this.betLevels = state.availableBetAmounts;
        this.betIndex = this.betLevels.findIndex((element) => {
            return element === state.betAmount;
        });
        this.gridSelector.select(this.betIndex);
        this.gridSelector.applyModifier();
        this.updateBetLevel();
    },

    updateBetLevel () {
        const bet = this.betIndex === -1 ? State.betAmount : this.betLevels[this.betIndex];
        const isIncEnabled = this.betIndex < this.betLevels.length - 1;
        const isDecEnabled = this.betIndex > 0;

        this.betAmounts.forEach((label) => {
            label.string = betValueDecorator(bet, State.selectedBooster, i18n);
        });

        this.incButtons.forEach((button) => {
            button.interactable = isIncEnabled && this.betEnabled;
            button.node.opacity = isIncEnabled && this.betEnabled ? 255 : 100;
        });

        this.decButton.forEach((button) => {
            button.interactable = isDecEnabled && this.betEnabled;
            button.node.opacity = isDecEnabled && this.betEnabled ? 255 : 100;
        });
    },

    decButtonClick () {
        if (this.betIndex === 0) {
            return;
        }

        if (State.isEnabled('betAmount')) {
            State.decrementBet();
            this.PSSound.playSfx(0);
        }
    },

    incButtonClick () {
        if (this.betIndex === this.betLevels.length - 1) {
            return;
        }

        if (State.isEnabled('betAmount')) {
            State.incrementBet();
            this.PSSound.playSfx(0);
        }
    },

    enableBet () {
        this.betEnabled = true;
        this.betButton.forEach((button) => {
            button.interactable = this.betEnabled;
            button.node.opacity = this.betEnabled ? 255 : 100;
        });
        this.updateBetLevel();
    },

    disableBet () {
        this.betEnabled = false;

        this.betButton.forEach((button) => {
            button.interactable = this.betEnabled;
            button.node.opacity = this.betEnabled ? 255 : 100;
        });

        this.incButtons.forEach((button) => {
            button.interactable = this.betEnabled;
            button.node.opacity = this.betEnabled ? 255 : 100;
        });

        this.decButton.forEach((button) => {
            button.interactable = this.betEnabled;
            button.node.opacity = this.betEnabled ? 255 : 100;
        });
    }

});
